import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    removePopupVisible: false,
};

const roleMenagmentSlice = createSlice({
    name: 'roleMenagment',
    initialState,
    reducers: {
        submitFormStart() {},
        setRemovePopupVisible(state, { payload }) {
            state.removePopupVisible = payload;
        },
        deleteRole() {},
    },
});

export const roleMenagmentActions = roleMenagmentSlice.actions;
export const roleMenagmentReducer = roleMenagmentSlice.reducer;
